import { render, staticRenderFns } from "./CompanyMultiselect.vue?vue&type=template&id=230270c4&scoped=true"
import script from "./CompanyMultiselect.vue?vue&type=script&lang=js"
export * from "./CompanyMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CompanyMultiselect.vue?vue&type=style&index=0&id=230270c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230270c4",
  null
  
)

export default component.exports